import React from 'react'
import {instance as elementTypeService} from '../../services/ElementTypeService'
import { CanvasEditorForElementsStep } from './CanvasEditorForElementsStep'

export function CanvasEditorSectors() {
  return (
    <CanvasEditorForElementsStep
      availableElementTypes={elementTypeService.getSectorElementTypes()}
    />
  )
}
